<script>
import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import { useCampaign } from 'shared/composables/useCampaign';
import CampaignCard from './CampaignCard.vue';

export default {
  components: {
    EmptyState,
    Spinner,
    CampaignCard,
  },
  props: {
    campaigns: {
      type: Array,
      default: () => [],
    },
    showEmptyResult: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    // const { isOngoingType } = useCampaign();
    // Comentado: ongoing removido - apenas one_off
    // return { isOngoingType };
    return {};
  },
  computed: {
    currentInboxId() {
      return this.$route.params.inboxId;
    },
    inbox() {
      return this.$store.getters['inboxes/getInbox'](this.currentInboxId);
    },
    inboxes() {
      // Comentado: ongoing removido - apenas one_off
      // if (this.isOngoingType) {
      //   return this.$store.getters['inboxes/getWebsiteInboxes'];
      // }
      const allInboxes = this.$store.getters['inboxes/getInboxes'];
      return allInboxes.filter(inbox =>
        ['Channel::Whatsapp', 'Channel::Iungo'].includes(inbox.channel_type)
      );
    },
    emptyMessage() {
      // Comentado: ongoing removido - apenas one_off
      // if (this.isOngoingType) {
      //   return this.inboxes.length
      //     ? this.$t('CAMPAIGN.ONGOING.404')
      //     : this.$t('CAMPAIGN.ONGOING.INBOXES_NOT_FOUND');
      // }

      return this.inboxes.length
        ? this.$t('CAMPAIGN.ONE_OFF.404')
        : this.$t('CAMPAIGN.ONE_OFF.INBOXES_NOT_FOUND');
    },
  },
};
</script>

<template>
  <div class="flex items-center flex-col">
    <div v-if="isLoading" class="items-center flex text-base justify-center">
      <Spinner color-scheme="primary" />
      <span>{{ $t('CAMPAIGN.LIST.LOADING_MESSAGE') }}</span>
    </div>
    <div v-else class="w-full">
      <EmptyState v-if="showEmptyResult" :title="emptyMessage" />
      <div v-else class="w-full">
        <CampaignCard
          v-for="campaign in campaigns"
          :key="campaign.id"
          :campaign="campaign"
          :is-ongoing-type="false"
          @view="campaign => $emit('view', campaign)"
          @delete="campaign => $emit('delete', campaign)"
          @pause="campaign => $emit('pause', campaign)"
          @resume="campaign => $emit('resume', campaign)"
          @cancel="campaign => $emit('cancel', campaign)"
          @export="campaign => $emit('export', campaign)"
          @viewRecipients="campaign => $emit('viewRecipients', campaign)"
        />
      </div>
    </div>
  </div>
</template>
